export {
    createThemeInstance,
    CustomThemeProvider,
    constructTheme,
    useCustomTheme,
} from '@atbay/theming'
import { CustomThemeInterface } from '@atbay/theming'
import { theme as darkTheme } from './theme-dark'
import { theme as lightTheme, theme } from './theme-light'

export type TTheme = typeof theme | typeof darkTheme

export const loadTheme = (themeVariant: string) =>
    themeVariant === 'light' ? lightTheme : darkTheme

export interface TThemeInterface extends Omit<CustomThemeInterface, 'fonts'> {
    fonts: CustomThemeInterface['fonts'] & TFonts
}

export type TFontWeight = 300 | 400 | 500 | 600 | 700

export type TFontSize =
    | '5rem'
    | '3.2rem'
    | '2.4rem'
    | '1.8rem'
    | '1.6rem'
    | '1.4rem'
    | '1.2rem'

export type TFontVariant =
    | 'xxxl-light'
    | 'xxxl-regular'
    | 'xxxl-medium'
    | 'xxxl-semibold'
    | 'xxxl-bold'
    | 'xxl-light'
    | 'xxl-regular'
    | 'xxl-medium'
    | 'xxl-semibold'
    | 'xxl-bold'
    | 'xl-light'
    | 'xl-regular'
    | 'xl-medium'
    | 'xl-semibold'
    | 'xl-bold'
    | 'l-light'
    | 'l-regular'
    | 'l-medium'
    | 'l-semibold'
    | 'l-bold'
    | 'm-light'
    | 'm-regular'
    | 'm-medium'
    | 'm-semibold'
    | 'm-bold'
    | 's-light'
    | 's-regular'
    | 's-medium'
    | 's-semibold'
    | 's-bold'
    | 'xs-light'
    | 'xs-regular'
    | 'xs-medium'
    | 'xs-semibold'
    | 'xs-bold'

export interface TFontDefinition {
    fontFamily: string
    fontWeight: TFontWeight
    fontSize: TFontSize
}

export type TFonts = Partial<Record<TFontVariant, TFontDefinition>>
